import Controller from "./application_controller"

/**
 * Behaviour for a checkbox input that toggles a state class when selected.
 * Enables the toggling of the checkbox input value by directly calling the controller.
 */
export default class extends Controller {
  static targets = ["input"]
  static classes = ["selected"]

  connect() {
    this.addEventListener(this.inputTarget, 'change', () => this.update())
  }

  update() {
    this.element.classList.toggle(this.selectedClass || 'selected', this.inputTarget.checked);
  }

  toggle(event) {
    if (event.defaultPrevented) return
    if (event.target === this.inputTarget) return

    event.preventDefault()

    this.inputTarget.checked = !this.inputTarget.checked
    this.update()
    this.inputTarget.dispatchEvent(new CustomEvent('change', { bubbles: true }))
  }
}
